var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSnagListIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "snag-left-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.743,
    height: 20.155,
    viewBox: "0 0 17.743 20.155",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M39.088,0a3.7,3.7,0,1,0,3.7,3.7A3.707,3.707,0,0,0,39.088,0ZM38.83,1.981a.258.258,0,0,1,.517,0V4.048a.258.258,0,0,1-.517,0Zm.258,3.7a.431.431,0,1,1,.431-.431A.431.431,0,0,1,39.088,5.685Z",
    transform: "translate(-25.049)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M14.93,23.773H0V5.111H10.464a4.1,4.1,0,0,0,.153,4.635,4.1,4.1,0,0,0,4.312,1.7ZM5.872,18.622A1.835,1.835,0,1,0,4.03,20.457a1.836,1.836,0,0,0,1.842-1.835Zm-1.826-6.63A1.835,1.835,0,1,0,2.2,10.158a1.833,1.833,0,0,0,1.843,1.834ZM5.872,14.4a1.835,1.835,0,1,0-3.67-.016,1.835,1.835,0,1,0,3.67.016Zm.845.227h5.75v-.478H6.716Zm5.753,4.229v-.473H6.718v.473ZM10.056,9.937H8.6c-.58,0-1.161,0-1.742,0-.062,0-.152-.032-.154.082,0,.136,0,.273,0,.409h3.347V9.937Z",
    transform: "translate(0 -3.618)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M10.587,46.786A1.321,1.321,0,1,1,9.239,48.1a1.325,1.325,0,0,1,1.348-1.314Zm-.81,1.539c.139.12.28.243.422.364a.252.252,0,0,0,.373-.011c.127-.121.249-.248.374-.372l.432-.429-.355-.366-.667.675-.194-.244-.384.383Z",
    transform: "translate(-6.54 -33.12)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M9.24,19.046a1.349,1.349,0,1,1,1.344,1.345A1.353,1.353,0,0,1,9.24,19.046Zm1.792-.592-.679.675-.195-.26-.373.387c.14.127.281.258.425.386a.23.23,0,0,0,.334.008c.292-.267.578-.541.871-.816l-.383-.38Z",
    transform: "translate(-6.54 -12.524)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M10.583,34.881a1.321,1.321,0,1,1,1.355-1.307A1.33,1.33,0,0,1,10.583,34.881Zm-.791-1.1.407.362a.231.231,0,0,0,.333.021c.289-.271.567-.555.834-.819L11.016,33l-.648.626-.2-.24Z",
    transform: "translate(-6.54 -22.822)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnagListIcon);
export default __webpack_public_path__ + "static/media/snagList-icon.c59f7e13674c753adb14c6dede1192d4.svg";
export { ForwardRef as ReactComponent };